const Article = () => {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 7.247V14.2692C13 14.7283 12.8104 15.1685 12.4728 15.4931C12.1352 15.8177 11.6774 16 11.2 16H2.8C2.32261 16 1.86477 15.8177 1.52721 15.4931C1.18964 15.1685 1 14.7283 1 14.2692V2.73077C1 2.27174 1.18964 1.83151 1.52721 1.50693C1.86477 1.18235 2.32261 1 2.8 1H6.50313C6.82127 1.00005 7.12638 1.12157 7.35138 1.33786L12.6486 6.43137C12.8736 6.64771 13 6.94108 13 7.247Z"
        stroke="#3C6EBE"
        strokeLinejoin="round"
      />
      <path
        d="M7 1.28906V5.61599C7 5.922 7.12643 6.21549 7.35147 6.43188C7.57652 6.64827 7.88174 6.76983 8.2 6.76983H12.7"
        stroke="#3C6EBE"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 9.65332H10"
        stroke="#3C6EBE"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12.5391H10"
        stroke="#3C6EBE"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Article;
